import script from "./CategoryMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./CategoryMenu.vue?vue&type=script&lang=ts&setup=true"

import "./CategoryMenu.vue?vue&type=style&index=0&id=68832b7b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68832b7b"]])

export default __exports__